import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="关于我们 - 菠萝视频"
        description="菠萝视频品牌介绍 - 海量高清视频在线观看平台，正版授权内容，覆盖电影、电视剧、综艺、动漫等多种类型，5000万+用户的选择。"
        keywords="菠萝视频,关于菠萝视频,视频平台,品牌介绍"
        canonicalUrl="https://www.boluovideo.com/about"
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
                关于菠萝视频
              </h1>
              <p className="text-lg text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                海量高清，随心观看 —— 您的一站式视频娱乐平台
              </p>
            </div>

            <div className="rounded-2xl overflow-hidden mb-14">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20office%20with%20large%20screens%20displaying%20movies%20and%20shows%2C%20warm%20cinematic%20lighting%2C%20creative%20workspace%20with%20comfortable%20seating%2C%20tech%20company%20vibe%2C%20orange%20and%20warm%20accent%20colors&width=1200&height=500&seq=boluo-about-hero&orientation=landscape"
                alt="菠萝视频团队"
                className="w-full aspect-[2.4/1] object-cover"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="p-6 rounded-xl bg-background-100">
                <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">品牌介绍</h2>
                <div className="space-y-4 text-foreground-700 leading-relaxed text-sm">
                  <p>
                    菠萝视频成立于2020年，是一家专注于在线视频内容分发的互联网科技公司。我们致力于为广大用户提供丰富、优质、流畅的视频观看体验。
                  </p>
                  <p>
                    平台内容涵盖<strong>电影、电视剧、综艺、动漫、纪录片、少儿</strong>等六大品类，拥有超过10万小时的高清正版视频内容库。无论是热播大片、经典剧集，还是独家综艺、精品动漫，菠萝视频都能满足您的观看需求。
                  </p>
                  <p>
                    我们与国内外多家顶级内容制作方建立了深度合作关系，持续引进和制作高品质内容，为用户提供最新、最全的视频资源。
                  </p>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-100">
                <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">核心优势</h2>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-shield-check-line"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">正版高清</h3>
                      <p className="text-xs text-foreground-500 mt-0.5">全站正版授权内容，1080P/4K超清画质，沉浸式观影体验</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-flashlight-line"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">极速流畅</h3>
                      <p className="text-xs text-foreground-500 mt-0.5">全球CDN加速节点，毫秒级加载，告别卡顿和缓冲</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                      <i className="ri-smartphone-line"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">多端同步</h3>
                      <p className="text-xs text-foreground-500 mt-0.5">支持Web、iOS、Android、TV等多终端观看，追剧不间断</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-user-heart-line"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">智能推荐</h3>
                      <p className="text-xs text-foreground-500 mt-0.5">AI算法精准匹配您的观影偏好，发现更多心头好内容</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-5 rounded-xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm text-secondary-500"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "资源真的很全，想看的电影基本都能找到，画质也非常清晰。推荐给所有爱看电影的朋友！"
                  </p>
                  <p className="text-xs text-foreground-500">—— 电影爱好者 李先生</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm text-secondary-500"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "追剧神器！更新速度超快，弹幕氛围也很好，一个人看剧也不孤单了。"
                  </p>
                  <p className="text-xs text-foreground-500">—— 追剧达人 王女士</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm text-secondary-500"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "给孩子看的动画内容很丰富，而且都有适龄标签，家长可以放心让孩子观看。"
                  </p>
                  <p className="text-xs text-foreground-500">—— 宝爸 张先生</p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-6">数据亮点</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="p-5 rounded-xl bg-background-100 text-center">
                  <p className="text-3xl font-bold text-accent-500 mb-1">5000万+</p>
                  <p className="text-sm text-foreground-500">注册用户</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 text-center">
                  <p className="text-3xl font-bold text-primary-500 mb-1">10万+</p>
                  <p className="text-sm text-foreground-500">小时内容</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 text-center">
                  <p className="text-3xl font-bold text-accent-500 mb-1">99.9%</p>
                  <p className="text-sm text-foreground-500">服务可用率</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 text-center">
                  <p className="text-3xl font-bold text-primary-500 mb-1">200+</p>
                  <p className="text-sm text-foreground-500">合作伙伴</p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-6">常见问题</h2>
              <div className="space-y-3">
                {[
                  {
                    q: '菠萝视频是否需要付费？',
                    a: '菠萝视频基础内容完全免费观看，部分独家内容可能需要会员权限。我们致力于让更多人享受优质视频内容。',
                  },
                  {
                    q: '支持哪些设备观看？',
                    a: '菠萝视频支持Web网页端、iOS、Android手机端、iPad平板端以及智能电视TV端，一个账号多端同步观看进度。',
                  },
                  {
                    q: '视频画质怎么样？',
                    a: '平台大部分内容支持1080P高清画质，部分精选内容提供4K超清画质选项，可根据网络情况自动调节最佳清晰度。',
                  },
                  {
                    q: '如何反馈问题或建议？',
                    a: '您可以通过页面底部的联系方式与我们取得联系，或发送邮件至 contact@boluovideo.com，我们会在24小时内回复。',
                  },
                ].map((faq, index) => (
                  <details key={index} className="group rounded-xl bg-background-100 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer">
                      <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                      <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>

            <div className="p-6 md:p-8 rounded-xl bg-background-100">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-900 text-sm mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@boluovideo.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-900 text-sm mb-1">客服热线</h3>
                    <p className="text-sm text-foreground-500">400-888-6666</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-900 text-sm mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">北京市朝阳区望京SOHO T1 15层</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
        <Footer />
      </div>
    </>
  );
}